import { render, staticRenderFns } from "./InputResultFilter.vue?vue&type=template&id=31720406&scoped=true&"
import script from "./InputResultFilter.vue?vue&type=script&lang=ts&"
export * from "./InputResultFilter.vue?vue&type=script&lang=ts&"
import style0 from "./InputResultFilter.vue?vue&type=style&index=0&id=31720406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31720406",
  null
  
)

export default component.exports
import {QInput,QBtn} from 'quasar'
component.options.components = Object.assign({QInput,QBtn}, component.options.components || {})
